<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>รีวิว {{ companyName }}</h2>
      </b-col>
    </b-row>
    <!-- <b-row class="mt-2 mb-2">
      <b-col>
        <b-card>
          <h5 class="text-logisty-profile-heading">ข้อมูลเบื่องต้น</h5>
          <b-row>
            <b-col sm="12" md="6" lg="4">
              <TextInput
                :value="$v.form.jobType"
                id="jobType"
                feedback="ระบุประเภทงาน"
                label="ประเภทงาน"
                placeholder="ตัวอย่าง : เหล็กเส้น, อาหารแห้ง"
                :isRequired="true"
              />
            </b-col>
            <b-col sm="12" md="6" lg="4">
              <b-form-group>
                <label for="period">ระยะเวลางาน</label>
                <b-input-group>
                  <b-form-input
                    v-model="$v.form.period.$model"
                    type="text"
                    id="period"
                    placeholder="ตัวอย่าง : 3"
                    :state="$v.form.period.$dirty ? !$v.form.period.$error : null"
                    aria-describedby="period-live-feedback"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-group>
                      <b-form-select
                        v-model="$v.form.periodUnit.$model"
                        :options="periodUnitOptions"
                        :state="$v.form.periodUnit.$dirty ? !$v.form.periodUnit.$error : null"
                        aria-describedby="periodUnit-live-feedback"
                      ></b-form-select>
                      <b-form-invalid-feedback id="periodUnit-live-feedback">เลือกหน่วย</b-form-invalid-feedback>
                    </b-form-group>
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback id="period-live-feedback">ตัวเลขเท่านั้น</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="4">
              <b-form-group>
                <label for="startDate">วันที่เริ่มงาน</label>
                <b-form-datepicker
                  v-model="$v.startDate.$model"
                  id="startDate"
                  :state="$v.startDate.$dirty ? !$v.startDate.$error : null"
                  aria-describedby="startDate-live-feedback"
                  class="mb-2"
                  locale="th"
                  placeholder="วันที่เริ่มงาน"
                ></b-form-datepicker>
                <b-form-invalid-feedback id="startDate-live-feedback">เลือกวันที่เริ่มงาน</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>-->
    <b-alert variant="success" :show="thisUpdate">คุณได้เขียนรีวิวแล้วเมื่อ {{ $moment(reviewedAt).format('LLL') }}</b-alert>
    <b-row class="mt-2 mb-2">
      <b-col>
        <b-card>
          <h5 class="text-logisty-profile-heading">รีวิว</h5>
          <b-row>
            <b-col class="mt-2" sm="12">
              <label for="rating">ให้คะแนน (5ดาว = ดีสุด)</label>
              <star-rating id="rating" :value="form.rating" @ratingUpdate="onRatingUpdate"></star-rating>
              <span class="logisty-custom-invalid-feedbace" v-if="$v.form.rating.$error">ให้คะแนน</span>
            </b-col>
            <b-col class="mt-2" sm="12">
              <!-- <TextInput
                :value="$v.form.content"
                id="content"
                feedback="ระบุคอมเมนต์"
                label="คอมเมนต์"
                placeholder="พิมพ์คอมเมนต์"
                :isRequired="true"
              />-->
              <b-form-group>
                <label for="rating">
                  แสดงความคิดเห็นเพิ่มเติม
                </label>
                <b-form-textarea
                  id="content"
                  v-model="$v.form.content.$model"
                  placeholder="ระบุความคิดเห็น"
                  rows="3"
                  max-rows="6"
                  :state="$v.form.content.$dirty ? !$v.form.content.$error : null"
                  aria-describedby="content-live-feedback"
                ></b-form-textarea>
                <b-form-invalid-feedback id="startDate-live-feedback">ระบุคอมเมนต์</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <!-- <b-col sm="12">
        <b-form-checkbox id="confirm" v-model="confirm">ขอรับรองว่ารีวิวนี้เป็นความจริง</b-form-checkbox>
      </b-col>-->
      <b-col sm="12">
        <b-button class="mr-4" @click="$router.back()" variant="warning" >ยกเลิก</b-button>
        <b-button variant="primary" @click="submit">ส่งการรีวิว</b-button>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import TextInput from '../../components/TextInput'
import SelectInput from '../../components/SelectInput'
import ModalLoading from '../../components/ModalLoading'
import StarRating from '../../components/StarRating'

import Profile from '../../services/http/Profile'

import { validationMixin } from 'vuelidate'
import { required, requiredIf, between, decimal, helpers, url, numeric, email } from 'vuelidate/lib/validators'

export default {
  components: {
    TextInput,
    SelectInput,
    ModalLoading,
    StarRating
  },
  mixins: [validationMixin],
  validations: {
    form: {
      jobType: {
        // required
      },
      period: {
        // numeric
      },
      periodUnit: {
        // required: requiredIf(function () {
        //   return this.form.period > 0
        // })
      },
      content: {
        // required
      },
      rating: {
        required,
        numeric,
        between: between(1, 5)
      }
    },
    startDate: {
      // required
    }
  },
  data () {
    return {
      form: {
        jobType: null,
        period: null,
        periodUnit: null,
        startDate: null,
        content: '',
        rating: 0
      },
      startDate: null,
      confirm: false,
      companyName: '',
      revieweeId: null,
      periodUnitOptions: [
        { value: null, text: 'ไม่ระบุ' },
        { value: 'วัน', text: 'วัน' },
        { value: 'สัปดาห์', text: 'สัปดาห์' },
        { value: 'เดือน', text: 'เดือน' },
        { value: 'ปี', text: 'ปี' }
      ],
      thisUpdate: false,
      reviewedAt: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      var profile = new Profile()

      Window.Event.$emit('showModalLoading')
      try {
        var result = null

        result = await profile.getPublicProfile(this.$route.params.companyUrl)

        // get revieweeId
        if (result.code === 1) {
          let companyData = result.data

          if (this.$cookies.isKey('companyId')) {
            if (this.$cookies.get('companyId') === companyData._id) {
              await this.$bvModal.msgBoxOk('ไม่สามารถรีวิวตัวเองได้', this.$getConst('okModalClass'))
              this.$router.push({ name: 'โปรไฟล์', params: { companyUrl: this.$route.params.companyUrl } })
            }
          }

          this.companyName = companyData.name
          this.revieweeId = companyData._id

          // get old review content
          let ratingReview = await profile.getOneRatingReview(this.revieweeId)
          if (ratingReview.code === 1 && !this.lodash.isEmpty(ratingReview.data)) {
            this.thisUpdate = true
            this.form.rating = ratingReview.data.rating
            this.form.content = ratingReview.data.content
            this.reviewedAt = ratingReview.data.createdAt
          }
        } else {
          await this.$bvModal.msgBoxOk('ไม่พบข้อมูล', this.$getConst('okModalClass'))
        }
      } catch (error) {
        console.log(error)
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
      }

      Window.Event.$emit('closeModalLoading')
    },
    async submit () {
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }

      let profile = new Profile()

      let data = {
        revieweeId: this.revieweeId,
        ...this.form
      }

      Window.Event.$emit('showModalLoading')
      try {
        let result = await profile.addRatingReview(data)
        if (result.code === 1) {
          await this.$bvModal.msgBoxOk('บันทึกข้อมูลแล้ว', this.$getConst('okModalClass'))
          this.$router.push({ name: 'โปรไฟล์', params: { companyUrl: this.$route.params.companyUrl } })
        } else {
          await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        }
      } catch (error) {
        console.log(error)
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
      }

      Window.Event.$emit('closeModalLoading')
    },
    onRatingUpdate (data) {
      this.form.rating = data
    }
  }
}
</script>
